import { useState } from 'react';
import { remindAsk, type RemindSubject } from '@/lib/remindAsk';

/**
 * Remind, on what I asked of others (My work, Waiting on others). After the
 * click it says what happened: reminded, or already reminded today.
 */
export function RemindButton({ type, id }: { type: RemindSubject; id: string }) {
  const [state, setState] = useState<'idle' | 'sending' | 'sent' | 'already' | 'error'>('idle');
  const [error, setError] = useState<string | null>(null);

  if (state === 'sent') return <span className="text-xs text-[var(--text-sec)]">Reminded.</span>;
  if (state === 'already') return <span className="text-xs text-[var(--text-sec)]">Already reminded today.</span>;

  const send = async () => {
    setState('sending');
    setError(null);
    const r = await remindAsk(type, id);
    if (!r.ok) {
      setState('error');
      setError(r.error);
      return;
    }
    setState(r.reminded > 0 ? 'sent' : 'already');
  };

  return (
    <>
      <button
        type="button"
        disabled={state === 'sending'}
        onClick={() => void send()}
        className="text-xs px-2.5 py-1 border border-[var(--rule)] hover:bg-[var(--hover-tint)] disabled:opacity-60"
      >
        {state === 'sending' ? 'Reminding…' : 'Remind'}
      </button>
      {error && <span className="text-xs text-[var(--text-sec)]">Not sent: {error}</span>}
    </>
  );
}
